import styled from 'styled-components';

const Popper = styled.div`
  filter: none !important;
`;

export const Styled = {
  Popper,
};
